import React from 'react';
import HelpButton from '../Admin/HelpButton';

interface SEOQuickActionsProps {
  onAction?: (action: string) => void;
}

const SEOQuickActions: React.FC<SEOQuickActionsProps> = ({ onAction }) => {
  const quickActions = [
    { id: 'fix-all', icon: 'fas fa-magic', label: 'Fix All Issues', color: '#8B4513' },
    { id: 'generate-descriptions', icon: 'fas fa-file-alt', label: 'Generate Missing Descriptions', color: '#3b82f6' },
    { id: 'optimize-images', icon: 'fas fa-compress', label: 'Optimize All Images', color: '#10b981' },
    { id: 'generate-structured-data', icon: 'fas fa-code', label: 'Generate Structured Data', color: '#f59e0b' },
    { id: 'run-health-check', icon: 'fas fa-heartbeat', label: 'Run Health Check', color: '#ef4444' },
    { id: 'generate-sitemap', icon: 'fas fa-sitemap', label: 'Generate Sitemap', color: '#6366f1' },
    { id: 'validate-urls', icon: 'fas fa-link', label: 'Validate All URLs', color: '#8b5cf6' }
  ];

  const handleAction = (actionId: string) => {
    if (onAction) {
      onAction(actionId);
    }
  };

  return (
    <div className="seo-quick-actions">
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '1rem' }}>
        <h3>Quick Actions</h3>
        <HelpButton section="seo" tooltip="Quick Actions Help" />
      </div>
      {quickActions.map(action => (
        <button
          key={action.id}
          className="quick-action-btn"
          onClick={() => handleAction(action.id)}
          style={{ borderColor: action.color, color: action.color }}
        >
          <i className={action.icon}></i>
          <span>{action.label}</span>
        </button>
      ))}
    </div>
  );
};

export default SEOQuickActions;

